export default __webpack_public_path__ + "static/media/vision.10efd085.svg";